export default function DefaultAddressInfo({ getSellerData }) {
  return (
    <div className="w-100 px-1 overflow-x-auto">
      <table
        className="table table-striped table-bordered table-hover"
        style={{ width: "100%", direction: "rtl" }}
      >
        <thead>
          <tr>
            <th>استان</th>
            <th>شهر</th>
            <th>نام</th>
            <th>نام خوانوادگی</th>
            <th>تلفن همراه</th>
            <th>کد پستی</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.province?.faName ?? "-"}
            </td>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.city?.faName ?? "-"}
            </td>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.name ?? "-"}
            </td>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.family ?? "-"}
            </td>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.phone ?? "-"}
            </td>
            <td className="text-center">
              {getSellerData?.seller?.defaultAddress?.postCode ?? "-"}
            </td>
          </tr>
          <tr>
            <th>آدرس</th>
            <td className="text-left" colSpan={10}>
              {getSellerData?.seller?.defaultAddress?.address ?? "-"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
